const STATUS_CLASS: Record<string, string> = {
  planning: "badge-info",
  executing: "badge-warning",
  reducing: "badge-secondary",
  complete: "badge-success",
  aborted: "badge-error",
  // A reaped run is dead, not cancelled: distinct from aborted's red.
  orphaned: "badge-neutral",
};

export default function StatusBadge({ status }: { status: string }) {
  const cls = STATUS_CLASS[status] ?? "badge-ghost";
  return <span className={`badge badge-sm ${cls}`}>{status.replaceAll("_", " ")}</span>;
}
